export enum C3GraphicVersionStatus {
    Draft = 'Draft',
    Released = 'Released',
    Obsolete = 'Obsolete',
}
